import { CurrencyExchangeDetailsPage } from 'features/currency-exchange';

export const TechOperatorCurrencyExchangeDetailsPage: React.FC = () => (
  <CurrencyExchangeDetailsPage />
);
